// extracted by css-extract-rspack-plugin
export default {"container":"DraggingRowsOverlay_container__5Opsy","dropIn":"DraggingRowsOverlay_dropIn__nfc0w","badge":"DraggingRowsOverlay_badge__m5TN4"};